module.exports = __webpack_public_path__ + "static/media/Image-3_7.0f61eaa5.jpg";